import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MapPin, Phone, Clock, ArrowRight, Navigation } from "lucide-react";
import { api } from "@/api";

export default function Dealers() {
  const [studios, setStudios] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/studios").then(({ data }) => { setStudios(data); setLoading(false); });
  }, []);

  return (
    <div data-testid="dealers-page">
      <section className="relative h-[50vh] min-h-[360px] overflow-hidden">
        <img src="https://images.pexels.com/photos/6573252/pexels-photo-6573252.jpeg" alt="Golf course" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-black/55" />
        <div className="container-ping relative h-full flex flex-col justify-end pb-14">
          <span className="label-caps text-white/80 mb-3">Custom Fit. Custom Built.</span>
          <h1 className="heading-1 text-white">Find A Fitting Studio</h1>
        </div>
      </section>

      <section className="container-ping py-16">
        <p className="max-w-2xl text-lg text-muted-foreground leading-relaxed mb-12">
          Our authorised fitting studios across India are staffed by PING-trained specialists ready to dial your equipment to your exact swing.
        </p>
        {loading ? (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
            {Array.from({ length: 3 }).map((_, i) => <div key={i} className="h-44 bg-secondary animate-pulse" />)}
          </div>
        ) : studios.length === 0 ? (
          <p className="py-10 text-center text-muted-foreground">Studios coming soon. Please contact us for a fitting.</p>
        ) : (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="studios-grid">
            {studios.map((s) => (
              <div key={s.id} className="border border-border p-6 hover:border-[#0A0A0A] btn-transition" data-testid={`studio-${s.city.toLowerCase().replace(/\s/g, "-")}`}>
                <span className="label-caps text-[#E31837]">{s.city}</span>
                <h3 className="font-head text-xl font-bold uppercase tracking-tight mt-2">{s.name}</h3>
                <ul className="mt-4 space-y-2 text-sm text-muted-foreground">
                  <li className="flex items-start gap-2"><MapPin className="h-4 w-4 mt-0.5 shrink-0 text-[#0A0A0A]" /> {s.address}</li>
                  {s.phone && <li className="flex items-center gap-2"><Phone className="h-4 w-4 text-[#0A0A0A]" /> {s.phone}</li>}
                  {s.hours && <li className="flex items-center gap-2"><Clock className="h-4 w-4 text-[#0A0A0A]" /> {s.hours}</li>}
                </ul>
                <a
                  href={s.map_url || `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(`${s.name}, ${s.address}`)}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mt-5 inline-flex items-center gap-2 border border-[#0A0A0A] px-5 py-2.5 label-caps text-xs btn-transition hover:bg-[#0A0A0A] hover:text-white active:scale-95"
                  data-testid={`directions-${s.city.toLowerCase().replace(/\s/g, "-")}`}
                >
                  <Navigation className="h-3.5 w-3.5" /> Get Directions
                </a>
              </div>
            ))}
          </div>
        )}

        <div className="mt-14 bg-[#F4F4F5] border border-border p-10 flex flex-col md:flex-row items-center justify-between gap-6">
          <div>
            <h2 className="heading-3">Can't Find A Studio Near You?</h2>
            <p className="text-muted-foreground mt-2">Send us an enquiry and we'll help arrange a fitting or delivery.</p>
          </div>
          <Link to="/contact" className="bg-[#0A0A0A] text-white px-10 py-4 label-caps btn-transition hover:bg-black/80 active:scale-95 flex items-center gap-2 shrink-0" data-testid="dealers-contact-cta">
            Contact Us <ArrowRight className="h-4 w-4" />
          </Link>
        </div>
      </section>
    </div>
  );
}
